import type { LiveRecordInfo } from './types';

export const getLiveRecordCardActions = ({
  id,
  status,
  content_status,
  watermarked_playback_url,
}: Pick<LiveRecordInfo, 'id' | 'status' | 'content_status' | 'watermarked_playback_url'>) => {
  const hasPlaybackId = Boolean(id?.trim());
  const isViewable =
    status === 'completed' && content_status === 'allowed' && Boolean(watermarked_playback_url?.trim());

  return {
    canDelete: hasPlaybackId,
    canOpen: hasPlaybackId && isViewable,
    canShare: hasPlaybackId && isViewable,
  };
};

export const isLiveRecordPending = ({ status, content_status }: Pick<LiveRecordInfo, 'status' | 'content_status'>) =>
  status === 'processing' ||
  (status === 'completed' &&
    content_status !== 'allowed' &&
    content_status !== 'review_rejected' &&
    content_status !== 'review_failed');

/*
 * 刻意不再提供「按 tab 过滤回放」的前端助手。
 *
 * 分类由服务端做（列表接口带 live_mode 参数）。前端过滤是在分页之后发生的，
 * 每页各自筛一遍，切到子 tab 只会剩零星几条，用户以为「就这么多」——
 * 别照着旧写法把它加回来。
 */
